// Painel Super Master > Notificações — som de notificação por tipo de
// alerta (upload de arquivo, ver ALERT_TYPE_OPTIONS em
// alert-rules.service.ts para os 8 tipos válidos). GET é público (sem
// sessão nenhuma, nem de empresa nem de plataforma — ver comentário em
// notification-sounds.controller.ts no backend): lido tanto pela tela do
// Super Master quanto pelo app de qualquer empresa (ver
// use-notification-sound-player.ts), por isso usa gpsDriveGet e não o
// cliente da plataforma. Upload/remoção são exclusivos do Super Master
// (platformUploadFile/platformDelete, gpsdrive-platform-client.ts).
import { gpsDriveGet, resolveGpsDriveUrl } from "@/lib/api/gpsdrive-client";
import { platformDelete, platformGet, platformPost, platformUploadFile } from "@/lib/api/gpsdrive-platform-client";

export interface NotificationSoundEntry {
  alertKey: string;
  url: string;
  fileName: string;
  updatedAt: string;
}

export interface TestPushResult {
  tokensNotified: number;
  usedRealRule?: boolean;
}

export interface TestPushDeviceOption {
  id: number;
  name: string;
  status: "online" | "offline" | "unknown";
}

// O backend devolve `url` relativa ("/api/v1/storage/...") — passada direto
// pro `new Audio()` resolvia contra gpsdrive.com.br (frontend) e dava 404:
// som customizado nunca tocava no app da empresa (visto 2026-10-02).
const withAbsoluteUrl = (entry: NotificationSoundEntry): NotificationSoundEntry => ({
  ...entry,
  url: resolveGpsDriveUrl(entry.url),
});

export const gpsDriveNotificationSoundsService = {
  list: () =>
    gpsDriveGet<NotificationSoundEntry[]>("/api/v1/notification-sounds").then((entries) =>
      entries.map(withAbsoluteUrl),
    ),
  upload: (alertKey: string, file: File) =>
    platformUploadFile<NotificationSoundEntry>(`/api/v1/notification-sounds/${alertKey}`, file).then(
      withAbsoluteUrl,
    ),
  remove: (alertKey: string) => platformDelete(`/api/v1/notification-sounds/${alertKey}`),
  // Seletor do botão "Enviar teste" — frota inteira da plataforma (todas
  // as empresas), ver comentário em notification-sounds.controller.ts.
  listTestPushDevices: () =>
    platformGet<TestPushDeviceOption[]>("/api/v1/notification-sounds/test-push/devices"),
  // Botão "Enviar teste" — manda um push FCM real (alerta de vibração)
  // pro(s) usuário(s) autorizados no veículo, ver
  // notification-sounds.controller.ts#POST /test-push no backend.
  sendTestPush: (deviceId: number) =>
    platformPost<TestPushResult>("/api/v1/notification-sounds/test-push", { deviceId }),
};
